import React, { useState, useRef, useEffect } from 'react'
import { makeStyles, Box, Chip, useTheme, fade, useMediaQuery } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useImageTranslation } from 'src/hooks'
import { productCardData } from '../../../utils/constant'
import { selectItem, viewItemList } from 'src/utils/trackingCode'
const useStyles = makeStyles((theme) => ({
  cardContainer: {
    margin: theme.spacing(2, 0),
    display: 'flex',
    overflowX: 'scroll',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    justifyContent: 'space-between',
    // scrollBehavior: 'smooth',
    cursor: 'pointer',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  swiperSlide: {
    flexShrink: 0,
    borderRadius: theme.spacing(3),
    width: 294,
    background: '#fff',
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(33),
    },
  },
  productCard: {
    flexShrink: 0,
    width: '100%',
    height: '197px',
    borderRadius: '24px 24px 0 0',
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
    },
  },
  swiperSlideImgBox: {
    textAlign: 'left',
    // width: theme.spacing(27.5),
    fontWeight: 600,
    fontSize: 18,
    color: fade(theme.palette.common.black),
    [theme.breakpoints.down('xs')]: {
      fontSize: 16,
      width: theme.spacing(27.5),
    },
  },

  swiperSlideChipBox: {
    textAlign: 'left',
    borderRadius: 100,
    // position: 'absolute',
    bottom: 18,
    [theme.breakpoints.down('xs')]: {
      bottom: 16,
    },
  },
  swiperSlideChip: {
    borderRadius: theme.spacing(12.5),
    backgroundColor: '#F3F4F6',
    fontSize: 12,
    marginTop: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      maxWidth: 240,
    },
  },
}))

function HorizontalCardList(data) {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const [tImage] = useImageTranslation()
  const history = useHistory()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const [productCard, setProductCard] = useState([])
  const productCard1 = productCardData.map((item) => {
    return {
      ...item,
      img: tImage(item.img, 'webp'),
      name: t(item.name),
    }
  })
  const cardContainerRef = useRef(null)
  const [isDragging, setIsDragging] = useState(false)
  const [dragStartX, setDragStartX] = useState(null)
  const [scrollLeftStart, setScrollLeftStart] = useState(null)

  const handleMouseDown = (e) => {
    setIsDragging(true)
    setDragStartX(e.pageX)
    setScrollLeftStart(cardContainerRef.current.scrollLeft)
  }

  const handleMouseMove = (e) => {
    if (!isDragging) {
      return
    }
    const dragOffset = e.pageX - dragStartX
    cardContainerRef.current.scrollLeft = scrollLeftStart - dragOffset
  }

  const handleMouseUp = () => {
    setIsDragging(false)
  }
  useEffect(() => {
    const productCard2 = [...productCard1]
    if (data.data === '1') {
      productCard2.splice(1, 1)
    }
    if (data.data === '2') {
      productCard2.splice(0, 1)
    }
    if (data.data === 5) {
      productCard2.splice(2, 1)
    }
    if (data.data === 4) {
      productCard2.splice(3, 1)
    }
    if (data.data === 3) {
      productCard2.splice(4, 1)
    }
    setProductCard(productCard2)
    viewItemList('related_product', 'related_product', productCard2)
  }, [data.data !== ''])
  
  return (
    <div
      className={classes.cardContainer}
      ref={cardContainerRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      {productCard.map((item, index) => (
        <Box
          key={index}
          className={classes.swiperSlide}
          border=" 1px solid #D9D9D9"
          textAlign="center"
          display="flex"
          flexDirection="column"
          // justifyContent="space-between"
          height={isMobile ? 339 : 402}
          // position="relative"
          pb={3}
          id={item.id}
          // mx={1}
          onClick={() => {
            selectItem('related_product', 'Related Product', item, index)
            history.push(`/${i18n.language}${item.path}`)
          }}
        >
          <Box>
            <img className={classes.productCard} src={item.img} alt="product info banner" />
          </Box>
          <Box ml={isMobile ? 1.5 : 2} mr={isMobile ? 1.5 : 2}>
            <Box className={classes.swiperSlideImgBox} pt={2} whiteSpace="break-spaces">
              {item.name}
            </Box>
            {item.nameInclude ? (
              <Box textAlign="left" color="#4B5563" mb={1.5} mt={0.5} fontSize={isMobile ? 14 : 16}>
                {t('glossary.included_Take2Prophecy')}
              </Box>
            ) : (
              ''
            )}
            <Box
              fontWeight={600}
              color="secondary.main"
              textAlign="left"
              fontSize={isMobile ? 16 : 18}

              // mt={index === 1 && i18n.language !== 'en' ? 1.7 : 0}
            >
              {item.price}
            </Box>
            <Box className={classes.swiperSlideChipBox}>
              <Chip
                className={classes.swiperSlideChip}
                label={t('glossary.discount', { field: item.discountprice })}
              />
            </Box>
          </Box>
        </Box>
      ))}
    </div>
  )
}

export default HorizontalCardList
